export class Cliente {

    constructor(
        public tipoCliente = '',
        public tipoMoral = 'MORAL',
        public tipoFisica = 'FISICA',
        public clienteEspecial = 'ESPECIAL',
        public nombre = '',
        // Datos de cliente
        public paterno = '',
        public materno = '',
        public id = '',
        public rfc = '',
        public razonSocial = '',
        public sucursal = '',
        public calle = '',
        public no_ext = '',
        public no_int = '',
        public colonia = '',
        public municipio = '',
        public cp = '',
        public telefono = '',
        public celular = '',
        public email = '',
        // Comentarios
        public comentario = '',
        public comentarioINE = '',
        public comentarioSAT = '',
        public comentarioBURO = '',
        public comentarioACTA = '',
        public comentarioPODER = '',
        public comentarioDOMICILIO = '',
        public comentarioCARATULABANCARIA = '',
        public comentarioAVISO = '',
        public comentarioCONTRATO = '',
        public comentarioFACTURA = '',
        public comentarioPAGARE = '',
        public comentarioORDENTRABAJO = '',
        public comentarioCOMPROBANTEPAGO = '',
        public comentarioAVALINE = '',
        public comentarioAVALDOMICILIO = '',
        public comentarioOTROUNO = '',
        public comentarioOTRODOS = '',
        public diasServicio = '',
        // Contactos
        public contactoNombreUno = '',
        public contactoPuestoUno = '',
        public contactoCorreoUno = '',
        public contactoTelUno = '',
        public contactoCelUno = '',
        public contactoNombreDos = '',
        public contactoPuestoDos = '',
        public contactoCorreoDos = '',
        public contactoTelDos = '',
        public contactoCelDos = '',
        public contactoNombreTre = '',
        public contactoPuestoTre = '',
        public contactoCorreoTre = '',
        public contactoTelTre = '',
        public contactoCelTre = '',
        public contactoNombreCua = '',
        public contactoPuestoCua = '',
        public contactoCorreoCua = '',
        public contactoTelCua = '',
        public contactoCelCua = '',
        public cantidad = '',
    ) {
    }

}



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_model/Cliente.ts